import React from 'react';
import './errorPage.scss';

export default props => (
  <div className="error-page">
    <i className="fa fa-exclamation-triangle fa-4" aria-hidden="true"></i>
    <span>Ocorreu um erro ao carregar os dados, tente novamente mais tarde</span>
  </div>
);
